import './src/main.css'
import BorderBox4 from './src/main.vue'

export default function (Vue) {
  Vue.component(BorderBox4.name, BorderBox4)
}
